// extracted by mini-css-extract-plugin
export default {"card":"StatCard_card__X-hJi","label":"StatCard_label__fmPM8","value":"StatCard_value__depiU","sub":"StatCard_sub__6CqrO"};